export const DepartmentData = {
  tabs: [
    {
      label: 'All Departments',
      id: 1,
    },
  ],
};